import { lazy, Suspense, type ReactNode } from 'react'
import type { RouteObject } from 'react-router-dom'

import { RouteErrorBoundary } from '@/routes/error-boundary'

/**
 * Rotas do portal do associado, numa lista só para as duas entradas do SPA:
 * a aplicação da equipe (onde o portal segue em `/portal`) e a entrada própria
 * do portal (`portal.html`, PORTAL-01), servida no subdomínio da associação.
 *
 * Sessão PRÓPRIA em cookie, fora do RequireAuth e sem AppShell. O associado não
 * é usuário da plataforma: reusar a sessão da equipe lhe daria assento na mesma
 * mesa.
 */
const PortalLoginPage = lazy(() =>
  import('./portal-login-page').then((m) => ({ default: m.PortalLoginPage })),
)
const PortalPrimeiroAcessoPage = lazy(() =>
  import('./portal-primeiro-acesso-page').then((m) => ({
    default: m.PortalPrimeiroAcessoPage,
  })),
)
const PortalDashboardPage = lazy(() =>
  import('./portal-dashboard-page').then((m) => ({
    default: m.PortalDashboardPage,
  })),
)

/** Espera curta e neutra: o portal não tem o esqueleto do app da equipe. */
function comEspera(elemento: ReactNode) {
  return (
    <Suspense
      fallback={
        <p className="m-0 p-4 text-sm text-muted" role="status">
          Carregando...
        </p>
      }
    >
      {elemento}
    </Suspense>
  )
}

export const rotasDoPortal: RouteObject[] = [
  {
    path: '/portal/entrar',
    element: comEspera(<PortalLoginPage />),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/portal/primeiro-acesso',
    element: comEspera(<PortalPrimeiroAcessoPage />),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/portal',
    element: comEspera(<PortalDashboardPage />),
    errorElement: <RouteErrorBoundary />,
  },
]
